import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';
import {generateRoutePath} from '@epic-core/common';
import EpicGamesFooter from 'epic-games-footer/app/scripts/EpicGamesFooter';

class Footer extends React.Component {
    static propTypes = {
        history: PropTypes.object,
        footerStore: PropTypes.object
    };

    /**
     * Routes to link's href
     * @param {Object} link
     */
    addOnClick(link, history) {
        if (link && link.useCustomCallback && link.href) {
            link.onClick = e => {
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                history.push(generateRoutePath(link.href));
            };
        }
        return Immutable(link);
    }

    /**
     * Prepares the array of links for the footer
     * @param {array} links
     */
    setLinks(links) {
        links.forEach(link => {
            this.addOnClick(link, this.props.history);
        });

        return Immutable(links);
    }

    setCta(callToAction) {
        return callToAction;
    }

    render() {
        const footerStore = this.props.footerStore || {};
        const config = footerStore.config ? footerStore.config.asMutable({deep: true}) : {};
        const epicPropertyName = config.epicPropertyName || 'dev_epic_games';
        const links = this.setLinks(config.links || []);
        const moreLegalLinks = this.setLinks(config.moreLegalLinks || []);
        const callToAction = !config.enableNewsLetter ? this.setCta(config.callToAction || {}) : null;

        return (
            <EpicGamesFooter
                epicPropertyName={epicPropertyName}
                links={links}
                socialLinks={config.socialLinks || []}
                copyrights={config.copyrights || []}
                legalTags={config.legalTags || []}
                logos={config.logos || []}
                messages={config.messages || {}}
                moreLegalLinks={moreLegalLinks}
                callToAction={callToAction}
                newsLetterConfigs={config.newsLetterConfigs || {}}
                {...config}
            />
        );
    }
}

export default Footer;
